require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./rseaux-de-recherche-internationaux-0-0-7.json") })
        }
      }, "path---rseaux-de-recherche-internationaux-0-0-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---rseaux-de-recherche-internationaux-0-0-7!./.cache/json/rseaux-de-recherche-internationaux-0-0-7.json
// module id = 556
// module chunks = 231608221292675